import React, { useRef, useEffect, useState } from 'react';


const onEscape = function (action) {
  window && window.addEventListener('keydown', (e) => {
    if (e.key === "Escape") {
      action();
    };
  });
};


const Input = (props) => {
  const [value, setValue] = useState(props.value);
  const [original, setOriginal] = useState(props.value);
  const [updating, setUpdating] = useState(false);
  let unBlurFlag = false
  const inputRef = useRef();
  onEscape(() => {
    // setOriginal(value)
    // unBlurFlag = true
    //inputRef.current.blur();
    setValue(original)

    if (inputRef.current) {
      inputRef.current.blur(true);
    }
  });

  const onChange = (e) => {
    if (props.canEdit) {
      // e.stopPropagation()
      if (e.target.value !== value && !unBlurFlag) {
        setValue(e.target.value)
      }
    }
  }

  const onKeyUpValue = (e) => {
    // e.stopPropagation()
    // if (e.keyCode === 13) {
    //   setOriginal(value)
    //    unBlurFlag = true
    //   inputRef.current.blur();
    //   props.onSave(props.record, props.data, value)
    // }
  }

  const onBlur = (e) => {
    if (props.canEdit === false) {
      return null
    }
    let newValue = value ? value.trim() : value

    if (newValue && newValue.startsWith('(multiple values)')) {
      setValue(original)
    } else if (newValue !== original) {
      let metadata = {
        [props.field]: newValue
      }
      setValue(newValue)
      setUpdating(true)
      let ids = []
      props.assets.forEach(o => {
        ids.push(o.id)
      })
      ids = ids.join(' OR ')
      props.assetHelper.updateBulk(`id:(${ids})`, metadata)
    } else {
      setValue(newValue)
    }


  }

  const textRowCount = typeof value === 'array' ? value.split("\n").length : 1
  let newClass = 'ems_text ems_editable'
  if (props.noGrow) {
    newClass = 'noGrow'
  }

  let Element = <></>

  let disabled = props.assets && props.assets.length === 0 ? true : !props.canEdit
  let style = {}

  if (props.canEdit) {
    style = { border: '1px solid lightgrey' }
    if (props.type === 'number') {

      if (updating) {
        style = { border: '1px solid #0095e0' }
        Element = <input className={newClass} disabled={disabled} ref={inputRef} value={value} onChange={onChange.bind(this)} onKeyUp={onKeyUpValue.bind(this)} onBlur={onBlur.bind(this)} style={style} type="number" />
      } else {
        Element = <input className={newClass} disabled={disabled} ref={inputRef} value={value} onChange={onChange.bind(this)} onKeyUp={onKeyUpValue.bind(this)} onBlur={onBlur.bind(this)} style={style} type="number" />
      }
    } else {

      if (updating) {
        style = { border: '1px solid #0095e0' }
        Element = <textarea className={newClass} disabled={disabled} rows={textRowCount} ref={inputRef} value={value} onChange={onChange.bind(this)} onKeyUp={onKeyUpValue.bind(this)} onBlur={onBlur.bind(this)} style={style}  ></textarea>
      } else {
        Element = <textarea className={newClass} disabled={disabled} rows={textRowCount} ref={inputRef} value={value} onChange={onChange.bind(this)} onKeyUp={onKeyUpValue.bind(this)} onBlur={onBlur.bind(this)} style={style}  ></textarea>
      }

    }
  } else {
    //if field is a number check if its blank. if so enter 0.
    if (props.type === 'number') {
      if (!value) {
        Element = Element = <textarea className={newClass} disabled={disabled} rows={textRowCount} ref={inputRef} value={0} onChange={onChange.bind(this)} onKeyUp={onKeyUpValue.bind(this)} onBlur={onBlur.bind(this)} ></textarea>
      } else {
        Element = Element = <textarea className={newClass} disabled={disabled} rows={textRowCount} ref={inputRef} value={value} onChange={onChange.bind(this)} onKeyUp={onKeyUpValue.bind(this)} onBlur={onBlur.bind(this)} ></textarea>

      }
    } else {
      Element = Element = <textarea className={newClass} disabled={disabled} rows={textRowCount} ref={inputRef} value={value} onChange={onChange.bind(this)} onKeyUp={onKeyUpValue.bind(this)} onBlur={onBlur.bind(this)} ></textarea>
    }
  }

  return (
    <>
      {Element}
      {/* {updating ?
        <textarea className={newClass} disabled={disabled} rows={textRowCount} ref={inputRef} value={value} onChange={onChange.bind(this)} onKeyUp={onKeyUpValue.bind(this)} onBlur={onBlur.bind(this)} style={{ border: '1px solid #0095e0' }} />
        :
        <textarea className={newClass} disabled={disabled} rows={textRowCount} ref={inputRef} value={value} onChange={onChange.bind(this)} onKeyUp={onKeyUpValue.bind(this)} onBlur={onBlur.bind(this)} />
      } */}
    </>
  );


  // return (
  //   <textarea rows={textRowCount} ref={inputRef} value={value} onChange={onChange.bind(this)} onKeyUp={onKeyUpValue.bind(this)} onBlur={onBlur.bind(this)} />
  // );
};

export default Input;